import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/content";

export const Logo = ({ className = "", withText = true, size = 40 }) => (
  <Link
    to="/"
    aria-label="Jollof Fit Kingdom home"
    data-testid="site-logo"
    className={`group flex items-center gap-3 ${className}`}
  >
    <img
      src={IMAGES.jfLogo}
      alt="Jollof Fit Kingdom"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="rounded-full object-cover"
    />
    {withText && (
      <span className="font-heading text-base font-semibold tracking-[0.02em] text-white sm:text-lg">
        JOLLOF <span className="text-gold">FIT</span> KINGDOM
      </span>
    )}
  </Link>
);
